import React from 'react';
import TopBarMain from '../components/topbars/TopBarMain';
import { apiGetAllForumPosts, apiIsLoggedIn } from '../api/api';
import PostCard from '../components/cards/PostCard';
import { Link } from 'react-router-dom';

class ForumLandingPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            posts: null,
        };
    }

    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            window.href = '/';
        }

        const allPostsResponse = await apiGetAllForumPosts();
        if (!allPostsResponse.ok) {
            return;
        }

        const allPostsJson = await allPostsResponse.json();

        allPostsJson.posts.sort((a, b) => {
            if (a.TimeStamp > b.TimeStamp) {
                return -1;
            } else if (a.TimeStamp < b.TimeStamp) {
                return 1;
            }

            return 0;
        });

        this.setState({
            ...this.state,
            posts: allPostsJson.posts,
        });
    }

    render() {
        return (
            <div>
                <TopBarMain />
                <h2 style={{ textAlign: 'center' }}>Discussion Forum</h2>
                <h3 style={{ textAlign: 'center' }}><Link to='/post/create'>Create new post</Link></h3>
                {this.state.posts ?
                    <div>
                        {this.state.posts.map((post) => {
                            return (<PostCard key={post.UUID} uuid={post.UUID} timestamp={post.TimeStamp} user={post.User} title={post.Title} body={post.Body} />);
                        })}
                    </div>
                : null}
            </div>
        )
    }
}

export default ForumLandingPage;
